import axios from "axios";
import { HttpUtils } from "./common/HttpUtils";


/**
 * Service used to make calls to the VinDecoder API
 */
export class VinDecoderService {

    constructor(auth) {
        this._auth = auth;
        this._headers = HttpUtils.getHttpHeaders(auth, 'text/json');
        this._baseUrl = `${process.env.VUE_APP_VINDECODER_API_URL}`;
        this._apiKey = `${process.env.VUE_APP_VINDECODER_API_KEY}`;
    }

    /**
     * Responsible for retrieving the VcDb upload status of the given id.  If no id is provided
     * the method retrieves the status of the currently executing process (if there is one). 
     * @param {any} id
     * @returns status information associated with the requested proccess or undefined the process status is unavailable.
     */    
    getVcDbStatus(id) {
        if (id === null || id === undefined) {
            id = "current";
        }        
        const url = `${this._baseUrl}/v1/vcdb/import/status/${id}`;

        return new Promise((resolve, reject) => {
            const headers = {
                "Accept": "application/json",
                "x-api-key": this._apiKey
            };

            axios.get(url, { headers: headers }).then(response => {
                if (response.status === 200 || response.status === 201 || response.status === 202 || response.status === 204) {
                    if (response.data == null) {
                        resolve(null);
                    }
                    else {
                        resolve(response.data);
                    }
                } else {
                    window.tracer.error(`[e229362] ${response.status} not supported.`);
                    reject(response.status);
                }
            }).catch((e) => {
                reject(e);
            });
        });
    }

    /**
     * Responsible for calling a PUT request to the VinDecoder API that updates the ACES database
     * from a zipped series of JSON files.
     * @param file - reference to the zip file to upload
     * @returns a Promsie containing 
     */
    uploadVcDb(file) {
        const url = `${this._baseUrl}/v1/vcdb/import`;
        const formData = new FormData();
        formData.append("file", file);

        return new Promise((resolve, reject) => {
            const headers = {
                "Content-type": "multipart/form-data",
                "Accept": "application/json",
                "x-api-key": this._apiKey
            };

            axios.put(url, formData, { headers: headers }).then(response => {
                if (response.status === 204) {
                    resolve(true);
                } else if (response.status === 200 || response.status === 201 || response.status === 202) {
                    if (response.data == null) {
                        resolve(true);
                    }
                    else {
                        resolve(response.data);
                    }
                } else {
                    window.tracer.error(`[e229362] ${response.status} not supported.`);
                    reject(response.status);
                }
            }).catch((e) => {
                reject(e);
            });
        });
    }
}